import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './core/contexts/AuthContext';
import { NotificationProvider } from './core/contexts/NotificationContext';
import { LoadingProvider } from './core/contexts/LoadingContext';
import { ErrorBoundary } from './core/components/ErrorBoundary';
import { AppRoutes } from './core/routing/AppRoutes';
import { theme } from './core/theme/theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LoadingProvider>
        <ErrorBoundary>
          <NotificationProvider>
            <BrowserRouter>
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
            </BrowserRouter>
          </NotificationProvider>
        </ErrorBoundary>
        </LoadingProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
